/**
 * Client-side shapes for matter members (FE-305).
 * The collaborators BE contract is not finalized — once it lands, add zod read
 * schemas (src/matter/store/schemas.ts pattern) and map API reads to these types
 * inside useManageMatterMembers.
 */

export interface MatterCollaborator {
  userId: string
  displayName: string
  email: string
  orgRole: 'admin' | 'user' | null
  /** Data value stays 'collaborator' (ticket contract); the UI label is "Contributor". */
  matterRole: 'owner' | 'collaborator'
  addedAt: string
}

export interface OrgUserOption {
  userId: string
  displayName: string
  email: string
}

/** Permission summary shown to the inviter. */
export const kMatterMemberHint = 'Added team members can manage files and view chats and drafts for this matter. Collaborating on chronologies is coming soon.'

/**
 * Roles & Permissions popover copy for the collaborator ("Members") view (FE-421).
 * Only covers roles members can currently be added as — leave out roles that aren't locked down yet.
 */
export const kMatterRoleDescriptions: { label: string; description: string }[] = [
  { label: 'Owner', description: 'Only owners can add and remove collaborators' },
  { label: 'Contributor', description: 'Manage files and view all chats and drafts in this matter' },
]

export enum MemberListStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum AddMembersStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

/** Outcome of a single member removal; null = success, string = inline error message. */
export type RemoveMemberResult = string | null
